import AutoStartOnIcon from '../components/Icons/DeviceNavigationIcons/AutoStartOnIcon';
import {RangeModeOnIcon} from '../components/Icons/DeviceNavigationIcons/RangeModeOnIcon';
import {RememberHeatingProfileOnIcon} from '../components/Icons/DeviceNavigationIcons/RememberHeatingProfileOnIcon';
import {TunabilityOnIcon} from '../components/Icons/DeviceNavigationIcons/TunabilityOnIcon';
import {VibrationIntensityHighIcon} from '../components/Icons/DeviceNavigationIcons/VibrationIntensityHighIcon';
import {VibrationIntensityLowIcon} from '../components/Icons/DeviceNavigationIcons/VibrationIntensityLowIcon';
import {VibrationIntensityMidIcon} from '../components/Icons/DeviceNavigationIcons/VibrationIntensityMidIcon';
import aiAssistantSettingControls from '../consts/aiAssistant/aiAssistantSettingControls';
import settingNames from '../consts/device/settings/settingNames';
import vibrationIntensityModes from '../consts/device/settings/vibrationIntensityModes';
import {strCode} from '../consts/strCode';

// `isFullRow` gives a tile a row of its own
const AI_ASSISTANT_SETTINGS_CONFIG = {
    [settingNames.AUTO_START]: {
        control: aiAssistantSettingControls.TOGGLE,
        titleStrCode: strCode.HOME_PAGE_PERSONALISE_ITEM_AUTO_START_TITLE,
        Icon: AutoStartOnIcon,
    },
    [settingNames.TUNABILITY]: {
        control: aiAssistantSettingControls.TOGGLE,
        titleStrCode: strCode.HOME_PAGE_PERSONALISE_ITEM_TUNABILITY_TITLE,
        Icon: TunabilityOnIcon,
    },
    [settingNames.REMEMBER_HEATING_PROFILE]: {
        control: aiAssistantSettingControls.TOGGLE,
        titleStrCode: strCode.HOME_PAGE_PERSONALISE_ITEM_REMEMBER_HEATING_PROFILE_TITLE,
        Icon: RememberHeatingProfileOnIcon,
    },
    [settingNames.RANGE_MODE]: {
        control: aiAssistantSettingControls.TOGGLE,
        titleStrCode: strCode.HOME_PAGE_PERSONALISE_ITEM_RANGE_MODE_TITLE,
        Icon: RangeModeOnIcon,
    },
    [settingNames.VIBRATION_INTENSITY]: {
        control: aiAssistantSettingControls.SEGMENTED,
        titleStrCode: strCode.HOME_PAGE_PERSONALISE_ITEM_VIBRATION_INTENSITY_TITLE,
        isFullRow: true,
        options: [
            {
                value: vibrationIntensityModes.LOW,
                titleStrCode: strCode.DEVICE_SETTINGS_PAGE_VIBRATION_INTENSITY_LOW_TITLE,
                Icon: VibrationIntensityLowIcon,
            },
            {
                value: vibrationIntensityModes.MID,
                titleStrCode: strCode.DEVICE_SETTINGS_PAGE_VIBRATION_INTENSITY_MID_TITLE,
                Icon: VibrationIntensityMidIcon,
            },
            {
                value: vibrationIntensityModes.HIGH,
                titleStrCode: strCode.DEVICE_SETTINGS_PAGE_VIBRATION_INTENSITY_HIGH_TITLE,
                Icon: VibrationIntensityHighIcon,
            },
        ],
    },
};

export default AI_ASSISTANT_SETTINGS_CONFIG;
